import { render, staticRenderFns } from "./CommunityFilterGroups.vue?vue&type=template&id=3edf78de&scoped=true&"
import script from "./CommunityFilterGroups.vue?vue&type=script&lang=js&"
export * from "./CommunityFilterGroups.vue?vue&type=script&lang=js&"
import style0 from "./CommunityFilterGroups.vue?vue&type=style&index=0&id=3edf78de&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3edf78de",
  null
  
)

export default component.exports